<template>
  <div class="d-flex justify-center">
    <sf-large-button v-if="ssoSettings.ssoLoginExclusive" block :href="getSsoLoginUrl(ssoSettings)">
      {{ $t('signIn') }}
    </sf-large-button>
    <sf-text-button v-else size="small" :href="getSsoLoginUrl(ssoSettings)">
      {{ $t('login_sso') }}
    </sf-text-button>
  </div>
</template>

<script setup lang="ts">
import SfLargeButton from '@/components/button/SfLargeButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import { SSOSettings } from '@/generatedTypes'
import router from '@/router'
import { getRouteRedirect } from '@/router/helpers'
import { PropType } from 'vue'

defineProps({
  ssoSettings: {
    type: Object as PropType<SSOSettings>,
    required: true
  }
})

const getSsoLoginUrl = (ssoSettings: SSOSettings) => {
  return 'https://' + location.host + ssoSettings.url + getRouteRedirect(router)
}
</script>
